import template from './template.html'

export default {
  bindings: {
    category: '<'
  },
  template
}
